import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemMedicalCard } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import MedicalIdCardDialog from "../../Dialogs/lostWallet/MedicalIdCardDialog";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../../util/dateFormatting";

const MedicalIdCard: React.FunctionComponent<{ requestDataCallback(): void; walletItemMedicalCards: WalletItemMedicalCard[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [medicalIdCardDialogIsVisible, setMedicalIdCardDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const[medicalIdCardNumber,setMedicalIdCardNumber]: any = useState([]);
    const showDeleteWalletDialog = (selectedItem: WalletItemMedicalCard): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showMedicalIdCardDialog = (selectedItem: WalletItemMedicalCard): any => {
        setSelectedItem(selectedItem);
        setMedicalIdCardDialogIsVisible(true);
    };

    const closeMedicalIdCardDialog = (): any => {
        setMedicalIdCardDialogIsVisible(false);
    };
   const toggleMemberIDVisibility=(medicalCard:any)=>{
    if (medicalIdCardNumber.length > 0) {
        const index = medicalIdCardNumber.findIndex((element: any) => element.memberId ===  medicalCard.memberId);
     if (index >= 0) {
        medicalIdCardNumber.splice(index, 1);
        setMedicalIdCardNumber([...medicalIdCardNumber]);
    } 
     else {
        setMedicalIdCardNumber([...medicalIdCardNumber, medicalCard]);
     }
      } else {
        setMedicalIdCardNumber([...medicalIdCardNumber , medicalCard]);
     }
   }
    return (
        <React.Fragment>
            {props.walletItemMedicalCards &&
                props.walletItemMedicalCards.map((medicalCard: WalletItemMedicalCard, index) => (
                    <div className="data-row" key={"medical-card-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"medical-id-card-" + index}
                                onClick={() => toggle(`medical-id-card-${index}-details`, `medical-id-card-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="sr-only btn-toggle-status">Show</span> {medicalCard.cardType}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"medical-id-card-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"medical-id-card-" + index + "-title"}
                                    aria-labelledby={"medical-id-card-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-card-type"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.cardType")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-card-type"}>
                                                {medicalCard.cardType}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-member-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.memberName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-member-name"}>
                                                {medicalCard.memberName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-member-id"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.memberId")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-member-id"}>
                                               {medicalCard &&
                                                 medicalCard.memberId &&  medicalIdCardNumber.findIndex((element: any) => element.memberId ===  medicalCard.memberId) < 0 ?
                                                      `${"*".repeat(medicalCard.memberId.substr(0,medicalCard.memberId.length - 4).length)}${medicalCard.memberId.substr(
                                                        medicalCard.memberId.length - 4
                                                      )}`: medicalCard.memberId  } 

<button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                    toggleMemberIDVisibility(medicalCard);
                                                }}
                                                title={tLang("identityVault.secureStorage.lostWallterWidget.cardTooltipMsg")}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            medicalIdCardNumber.findIndex((element: any) => element.memberId ===  medicalCard.memberId) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide CardMemberId Text</span>
                                            </button>     
                                             </div>
                                        </div>
                                   </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-provider-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.providerName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-provider-name"}>
                                                {medicalCard.providerName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-provider-phone-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.providerPhone")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-provider-phone-number"}>
                                               
                                              {medicalCard.providerPhoneNumber}
                                               
                                          </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-provider-address"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.providerAddress")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-provider-address"}>
                                                {medicalCard.providerAddress}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-issue-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.issueDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-issue-date"}>
                                                {medicalCard.issueDate && getFormattedDate(i18nService.get("Country"), medicalCard.issueDate)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-group"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.group")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-group"}>
                                                {medicalCard.group}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"medical-id-card-" + index + "-bin"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.label.bin")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"medical-id-card-" + index + "-bin"}>
                                                {medicalCard.bin}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(medicalCard)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id={"edit-medical-card-" + index}
                                                    onClick={() => showMedicalIdCardDialog(medicalCard)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-medical-id-card-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="medical-id-card"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {medicalIdCardDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-social-security-card-wallet" title="Edit Social Security Card Wallet" closeDialog={closeMedicalIdCardDialog}>
                    <MedicalIdCardDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeMedicalIdCardDialog}
                        walletItem={selectedItem}
                        isNew={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default MedicalIdCard;
